module.exports = __webpack_public_path__ + "170b4bd580228b7d8d271c5881e6a48f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/allianz_funds.png
// module id = 1600
// module chunks = 0